import {
  FilterCheckboxType,
  InvoiceType,
  LinkedSingleColumnType,
} from "@/redux/invoicingAdvance/invoicingAdvance-types";

import {
  BankStatementHeader,
  FilterByPaymentStatusType,
  InvoicingAdvanceHeadersType,
  LabeledValue,
  SinglePdfHeaderType,
  TabType,
  TDSTCSRadioType,
} from "@/components/InvoicingAdvance/helpers/invoicingAdvance-type";

import { StatusType } from "@/commonTypes/mySpaceType";
import { RadioTypes } from "@/commonTypes/universalTypes";

export const INVOICINGADVANCETABS: TabType[] = [
  {
    name: "Expense Invoices",
    label: "expenses",
    display: false,
    id: "expense",
  },
  {
    name: "Sales Invoices",
    label: "revenues",
    display: false,
    id: "sales",
  },
  {
    name: "Other Entries",
    label: "others",
    display: false,
    id: "other",
  },
  {
    name: "Manufacturing Journal",
    label: "manufacturingJournal",
    display: false,
    id: "manufacturing",
  },
];

// this is used for expenses and sales invoice list
export const EXPENSES_INVOICES_LIST_HEADERS: InvoicingAdvanceHeadersType[] = [
  {
    label: "NAME",
    value: "supplier_name",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "INVOICE NO.",
    value: "voucher_invoice_number",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "INVOICE DATE",
    value: "voucher_invoice_date",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "TOTAL AMOUNT",
    value: "net_amount",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "ATTACHMENTS",
    value: "upload",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "MODIFIED BY",
    value: "company_name",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "APPROVED BY",
    value: "approved_by",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "PAYMENT STATUS",
    value: "payment_status",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "Created At",
    value: "created_at",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "",
    value: "extraColumn",
    defaultChecked: true,
    checked: true,
  },
];

export const OTHERS_INVOICES_LIST_HEADERS: InvoicingAdvanceHeadersType[] = [
  {
    label: "DOCUMENT ID",
    value: "others_id",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "DOCUMENT DATE",
    value: "date_of_invoice",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "DETAILS",
    value: "payment",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "BRANCH",
    value: "branch_details",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "ATTACHMENTS",
    value: "upload",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "MODIFIED BY",
    value: "company_name",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "APPROVED BY",
    value: "approved_by",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "Created At",
    value: "created_at",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "",
    value: "extraColumn",
    defaultChecked: true,
    checked: true,
  },
];

export const TABACTIONCONFIG: Record<
  InvoiceType,
  {
    search: boolean;
    bulkUpload: boolean;
    paymentStatusFilter: boolean;
    filter: boolean;
    sorting: boolean;
    downloadReport: boolean;
    lockEntry: boolean;
    overdueReminderToggle?: boolean;
  }
> = {
  expenses: {
    search: true,
    bulkUpload: true,
    paymentStatusFilter: true,
    filter: true,
    sorting: true,
    downloadReport: true,
    lockEntry: true,
  },
  revenues: {
    search: true,
    bulkUpload: true,
    paymentStatusFilter: true,
    filter: true,
    sorting: true,
    downloadReport: true,
    lockEntry: true,
    overdueReminderToggle: true,
  },
  others: {
    search: true,
    bulkUpload: true,
    filter: true,
    sorting: true,
    paymentStatusFilter: false,
    downloadReport: true,
    lockEntry: true,
  },
  manufacturingJournal: {
    search: true,
    bulkUpload: false,
    paymentStatusFilter: false,
    filter: true,
    sorting: true,
    downloadReport: true,
    lockEntry: true,
  },
};

export const PERMISSION_KEY_MAP: Record<
  InvoiceType,
  { bulkUpload: string; downloadReport: string; lockEntry: string }
> = {
  expenses: {
    bulkUpload: "isBulkUploadExpensePresent",
    downloadReport: "isDownloadExpenseReportPresent",
    lockEntry: "isLockExpenseEntriesPresent",
  },
  revenues: {
    bulkUpload: "isBulkUploadSalesPresent",
    downloadReport: "isDownloadSalesReportPresent",
    lockEntry: "isLockSalesEntriesPresent",
  },
  others: {
    bulkUpload: "isBulkUploadOtherPresent",
    downloadReport: "isDownloadOtherReportPresent",
    lockEntry: "isLockOtherEntriesPresent",
  },
  manufacturingJournal: {
    bulkUpload: "isBulkUploadManufacturingPresent",
    downloadReport: "isDownloadManufacturingAllowed",
    lockEntry: "isLockManufacturingEntriesPresent",
  },
} as const;

export const FILTERBYPAYMENTSTATUS: FilterByPaymentStatusType[] = [
  {
    label: "All Status",
    value: "all_status",
    defaultChecked: true,
    checked: true,
    key: "all",
  },
  {
    label: "Partial Paid",
    value: "1",
    defaultChecked: true,
    checked: true,
    key: "partiallyPaid",
  },
  {
    label: "Pending",
    value: "0",
    defaultChecked: true,
    checked: true,
    key: "pending",
  },
  {
    label: "Paid",
    value: "2",
    defaultChecked: true,
    checked: true,
    key: "paid",
  },
  {
    label: "Purchase Order",
    value: "3",
    defaultChecked: true,
    checked: true,
    key: "purchaseOrder",
  },
];

export const FILTER_BY_PAYMENT_STATUS_REVENUES: FilterByPaymentStatusType[] = [
  {
    label: "All Status",
    value: "all_status",
    defaultChecked: true,
    checked: true,
    key: "all",
  },
  {
    label: "Partial Paid",
    value: "1",
    defaultChecked: true,
    checked: true,
    key: "partiallyPaid",
  },
  {
    label: "Pending",
    value: "0",
    defaultChecked: true,
    checked: true,
    key: "pending",
  },
  {
    label: "Paid",
    value: "2",
    defaultChecked: true,
    checked: true,
    key: "paid",
  },
  {
    label: "Estimation",
    value: "3",
    defaultChecked: true,
    checked: true,
    key: "estimation",
  },
];

export const DATE_FILTER_OPTION: RadioTypes[] = [
  {
    id: "1",
    _id: "Creation_date",
    name: "Invoice Creation Date",
  },
  {
    id: "2",
    _id: "Invoice_date",
    name: "Invoice Date",
  },
];

export const INVOICE_CATEGORY_CHECKBOXES_EXPENSE: FilterCheckboxType[] = [
  { label: "E-Way Bill", isChecked: false, value: "e_way_bill_status" },
];

// Allocation status checkboxes
export const ALLOCATION_STATUS_CHECKBOXES: FilterCheckboxType[] = [
  { label: "Allocated", isChecked: false, value: "allocated" },
  { label: "Partially Allocated", isChecked: false, value: "partial" },
  { label: "Unallocated", isChecked: false, value: "unallocated" },
];

export const CREATED_THROUGH_CHECKBOXES_EXPENSE: FilterCheckboxType[] = [
  { label: "GSTR-2A", isChecked: false, value: "2a" },
  { label: "GSTR-2B", isChecked: false, value: "2b" },
  { label: "Bulk Upload", isChecked: false, value: "bulk_upload" },
  {
    label: "OCR",
    isChecked: false,
    value: "ocr",
  },
  { label: "Manual Invoice", isChecked: false, value: "manual" },
];

export const DOCUMENT_TYPE_CHECKBOXES_EXPENSE: FilterCheckboxType[] = [
  { label: "Tax Invoice", isChecked: false, value: "tax_invoice" },
  { label: "Credit Note", isChecked: false, value: "credit_note" },
  { label: "Debit Note", isChecked: false, value: "debit_note" },
  {
    label: "RCM (Reverse Charge Mechanism)",
    isChecked: false,
    value: "rcm_invoice",
  },
  { label: "Purchase Order", isChecked: false, value: "purchase_order" },
];

export const INVOICE_CATEGORY_CHECKBOXES_SALES: FilterCheckboxType[] = [
  { label: "E-Invoice", isChecked: false, value: "einvoice_status" },
  { label: "E-Way Bill", isChecked: false, value: "e_way_bill_status" },
  { label: "GSTR-1", isChecked: false, value: "is_gstr1_filed" },
];
export const DOCUMENT_TYPE_CHECKBOXES_SALES: FilterCheckboxType[] = [
  { label: "Tax Invoice", isChecked: false, value: "tax_invoice" },
  { label: "Credit Note", isChecked: false, value: "credit_note" },
  { label: "Debit Note", isChecked: false, value: "debit_note" },
  { label: "Estimation", isChecked: false, value: "estimation" },
];

export const CREATED_THROUGH_CHECKBOXES_SALES: FilterCheckboxType[] = [
  { label: "Bulk Upload", isChecked: false, value: "bulk_upload" },
  {
    label: "OCR",
    isChecked: false,
    value: "ocr",
  },
  { label: "Manual Invoice", isChecked: false, value: "manual" },
];

export const CREATED_THROUGH_CHECKBOXES_OTHERS: FilterCheckboxType[] = [
  { label: "Bulk Upload", isChecked: false, value: "bulk_upload" },
  {
    label: "Upload Bank Statement",
    isChecked: false,
    value: "upload_bank_statement",
  },
  { label: "Manual Invoice", isChecked: false, value: "manual" },
];

export const APPROVAL_RADIO_OPTIONS: RadioTypes[] = [
  {
    id: "1",
    _id: "App_1",
    name: "Approved",
  },
  {
    id: "0",
    _id: "App_0",
    name: "Unapproved",
  },
  {
    id: "2",
    _id: "App_2",
    name: "Approved By Me",
  },
  {
    id: "3",
    _id: "App_3",
    name: "Approved By Others",
  },
];

export const ATTACHMENT_RADIO_OPTIONS: RadioTypes[] = [
  {
    id: "1",
    _id: "Att_1",
    name: "With File Attachment",
  },
  {
    id: "0",
    _id: "Att_0",
    name: "Without File Attachment",
  },
];

export const COMMENT_RADIO_OPTIONS: RadioTypes[] = [
  {
    id: "1",
    _id: "Comm_1",
    name: "With Comment",
  },
  {
    id: "0",
    _id: "Comm_0",
    name: "Without Comment",
  },
];

// getSortingParamsfunction has dependency on id so while updating id also update the function to avoid error in sorting
export const INVOICE_DATE_SORTING_RADIO_OPTIONS: RadioTypes[] = [
  {
    id: "default",
    _id: "default",
    name: "Recently Modified First",
  },
  {
    id: "invoice_date_asc",
    _id: "asc",
    name: "Invoice Date - Ascending",
  },
  {
    id: "invoice_date_desc",
    _id: "desc",
    name: "Invoice Date - Descending",
  },
  {
    id: "invoice_number_asc",
    _id: "asc",
    name: "Invoice Number - Ascending",
  },
  {
    id: "invoice_number_desc",
    _id: "desc",
    name: "Invoice Number - Descending",
  },
];

export const OTHER_DATE_SHORTING_RADIO_OPTIONS: RadioTypes[] = [
  {
    id: "default",
    _id: "default",
    name: "Recently Modified First",
  },
  {
    id: "invoice_date_asc",
    _id: "asc",
    name: "Entries Date - Ascending",
  },
  {
    id: "invoice_date_desc",
    _id: "desc",
    name: "Entries Date - Descending",
  },
];

export const PAYMENT_SECTION_FILTER_OPTIONS: RadioTypes[] = [
  { id: "1", name: "With Payment" },
  {
    id: "0",
    name: "Without Payment",
  },
];

export const ROUTE_NAME = "invoice-generation";
export const RADIO_OPTIONS_YES_NO: RadioTypes[] = [
  {
    id: "0",
    name: "Yes",
  },
  {
    id: "1",
    name: "No",
  },
];

export const ITEM_HEADER = [
  {
    label: "No",
    value: "no",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "Item Name",
    value: "description_as_per_bill",
    defaultChecked: true,
    checked: true,
  },

  {
    label: "HSN/SAC",
    value: "hsn_sac_code",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "Quantity",
    value: "quantity",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "Unit",
    value: "unit",
    defaultChecked: true,
    checked: true,
  },

  {
    label: "Total Value",
    value: "total_value",
    defaultChecked: true,
    checked: true,
  },
];

export const TDS_TCS_RADIO_OPTIONS: TDSTCSRadioType[] = [
  {
    id: "tds",
    name: "TDS",
  },
  {
    id: "tcs",
    name: "TCS",
  },
];

export const PDF_TABLE_HEADERS: SinglePdfHeaderType[] = [
  {
    name: "No",
    column_value: "no",
  },
  {
    name: "Description",
    column_value: "description",
  },
  {
    name: "HSN/SAC",
    column_value: "hsn_sac_code",
  },
  {
    name: "SKU",
    column_value: "sku_code",
  },
  {
    name: "Rate",
    column_value: "rate",
  },
  {
    name: "Qty",
    column_value: "quantity",
  },
  {
    name: "Amount",
    column_value: "amount",
  },
  {
    name: "Discount",
    column_value: "discount",
  },
  {
    name: "Taxable",
    column_value: "taxable_value",
  },
  {
    name: "GST %",
    column_value: "gst_percentage",
  },
  {
    name: "IGST",
    column_value: "igst_amount",
  },
  {
    name: "CGST",
    column_value: "cgst_amount",
  },
  {
    name: "SGST",
    column_value: "sgst_amount",
  },
  {
    name: "Total",
    column_value: "total_value",
  },
];

export const GST_SUMMARY_HEADERS: SinglePdfHeaderType[] = [
  {
    name: "GST Summary",
    column_value: "gst_percentage",
  },
  {
    name: "Amount",
    column_value: "total_taxable_amount",
  },
  {
    name: "IGST",
    column_value: "total_igst_amount",
  },
  {
    name: "CGST",
    column_value: "total_cgst_amount",
  },
  {
    name: "SGST",
    column_value: "total_sgst_amount",
  },
  {
    name: "Total",
    column_value: "total_amount",
  },
];

export const BULK_UPLOAD_RADIO_OPTIONS: RadioTypes[] = [
  {
    id: "0",
    name: "Normal Bulk Upload",
  },
  {
    id: "1",
    name: "Suspense Bulk Upload",
  },
];

export const BULK_UPLOAD_HISTORY_LIST_HEADERS = [
  {
    label: "File Name",
    value: "file_name",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "File Url",
    value: "file_url",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "Stage",
    value: "stage",
    defaultChecked: true,
    checked: true,
    width: "80px",
  },
  {
    label: "Uploaded At",
    value: "created_at",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "Updated At",
    value: "updated_at",
    defaultChecked: true,
    checked: true,
  },
];

export const CANCEL_EWAYBILL_OPTION = [
  { id: "Duplicate", name: "Duplicate" },
  { id: "Order Cancelled", name: "Order Cancelled" },
  { id: "Data Entry mistake", name: "Data Entry mistake" },
  { id: "Others", name: "Others" },
];

export const TRANSACTION_TYPE_FOR_REVENUE = [
  {
    value: "Regular",
    label: "Regular",
  },
  {
    value: "Bill To - Ship To",
    label: "Bill To - Ship To",
  },
  {
    value: "Bill From - Dispatch From",
    label: "Bill From - Dispatch From",
  },
];
export const TRANSACTION_TYPE_FOR_EXPENSE = [
  {
    value: "Regular",
    label: "Regular",
  },
  {
    value: "Bill From - Dispatch From",
    label: "Bill From - Dispatch From",
  },
];
export const MODE = [
  { value: "Road", label: "Road" },
  { value: "Air", label: "Air" },
  { value: "Ship", label: "Ship" },
  { value: "Rail", label: "Rail" },
];

export const VEHICLE_TYPE = [
  { value: "Regular", label: "Regular" },
  { value: "Over Dimensional Cargo", label: "Over Dimensional Cargo" },
];
export const SUB_SUPPLY_TYPE = [
  { value: "Supply", label: "Supply" },
  { value: "Import", label: "Import" },
  { value: "Export", label: "Export" },
  { value: "Job Work", label: "Job Work" },
  { value: "For Own Use", label: "For Own Use" },
  { value: "Job work Returns", label: "Job work Returns" },
  { value: "Sales Return", label: "Sales Return" },
  { value: "Others", label: "Others" },
  { value: "SKD/CKD/Lots", label: "SKD/CKD/Lots" },
  { value: "Line Sales", label: "Line Sales" },
  { value: "Recipient Not Known", label: "Recipient Not Known" },
  { value: "Exhibition or Fairs", label: "Exhibition or Fairs" },
];

export const REASONS_FOR_EXTENSION = [
  { value: "Natural Calamity", label: "Natural Calamity" },
  { value: "Law and Order Situation", label: "Law and Order Situation" },
  { value: "Transshipment", label: "Transshipment" },
  { value: "Accident", label: "Accident" },
  { value: "Others", label: "Others" },
];
export const TRANSIT_TYPE = [
  { value: "Road", label: "Road" },
  { value: "Warehouse", label: "Warehouse" },
];
export const CONSIGNMENT_STATUS = [
  { value: "M", label: "In Movement" },
  { value: "T", label: "In Transit" },
];

export const VEHICLE_SECTION_RADIO_OPTIONS: RadioTypes[] = [
  {
    id: "vehicle_details",
    name: "Vehicle Details",
  },
  {
    id: "transporter_details",
    name: "Transporter Details",
  },
];

export const REASON_CODE = [
  {
    value: "Due to Break Down",
    label: "Due to Break Down",
  },
  {
    value: "Due to Transshipment",
    label: "Due to Transshipment",
  },
  {
    value: "Others (Pls. Specify)",
    label: "Others (Pls. Specify)",
  },
  {
    value: "First Time",
    label: "First Time",
  },
];

export const COLUMNS_USING_TO_OPTION_INITIAL = [
  "branch",
  "bill_from",
  "supplier_name",
  "customer_name",
  "mapping_tax_invoice",
  "ship_to_name",
  "nature_of_expense",
  "nature_of_income",
  "mode_of_payment",
  "mode_of_receipts",
  "batch_number",
];

// "NA" option for SKU Code, selected when the item has no SKU
export const SKU_NA_OPTION = { label: "NA", value: "NA" };

export const SHOW_CURRENCY_CONVERSION_FOR_COLUMNS = [
  "currency",
  "rate",
  "amount",
  "taxable_value",
  "total_value",
  "cgst_amount",
  "igst_amount",
  "sgst_amount",
  "discount",
];

export const BATCH_SUMMARY_HEADERS: SinglePdfHeaderType[] = [
  {
    name: "No",
    column_value: "no",
  },
  {
    name: "Description",
    column_value: "description",
  },
  {
    name: "Batch ID",
    column_value: "batch_id",
  },
  {
    name: "HSN/SAC",
    column_value: "hsn_sac_code",
  },
  {
    name: "SKU",
    column_value: "sku_code",
  },
  {
    name: "Rate",
    column_value: "rate",
  },
  {
    name: "Qty",
    column_value: "quantity",
  },
  {
    name: "Amount",
    column_value: "amount",
  },
  {
    name: "Discount",
    column_value: "discount",
  },
  {
    name: "Taxable",
    column_value: "taxable_value",
  },
  {
    name: "GST %",
    column_value: "gst_percentage",
  },
  {
    name: "IGST",
    column_value: "igst_amount",
  },
  {
    name: "CGST",
    column_value: "cgst_amount",
  },
  {
    name: "SGST",
    column_value: "sgst_amount",
  },
  {
    name: "Total",
    column_value: "total_value",
  },
];

export const OTHERS_COLUMNS_LIST_PRIMARY = [
  {
    id: 1,
    name: "Branch",
    column_name: "branch",
    data_type: "json",
    sequence: 1,
  },
  {
    id: 2,
    name: "Date",
    column_name: "date_of_invoice",
    data_type: "date",
    sequence: 2,
  },
  {
    id: 3,
    name: "Narration in Bank Statement",
    column_name: "narration_in_bank",
    data_type: "text",
    sequence: 3,
  },
];

export const EXTRA_PRIMARY_COLUMN_OTHERS: LinkedSingleColumnType[] = [
  {
    id: 1,
    name: "Additional Comments",
    column_name: "additional_comments",
    data_type: "text",
    sequence: 1,
    validation: [],
    xs: "9",
    isDisabled: false,
    isVisible: true,
    linkedColumns: [],
  },
];

export const OTHERS_COLUMNS_LIST_PAYMENT = [
  {
    id: 1,
    name: "",
    column_name: "sent/received",
    data_type: "json",
    sequence: 1,
  },
  {
    id: 2,
    name: "",
    column_name: "mode_of_payment",
    data_type: "json",
    sequence: 2,
  },
  {
    id: 3,
    name: "",
    column_name: "sent/received amount",
    data_type: "text_with_symbol",
    sequence: 3,
  },
];

export const TRANSACTION_TYPES: LabeledValue[] = [
  {
    value: "debit",
    label: "Sent(Debit)",
  },
  {
    value: "credit",
    label: "Received(Credit)",
  },
];

export const ALTERNATIVE_COLUMNS_LIST_PAYMENT = [
  {
    id: -901,
    name: "Alternative Unit",
    column_name: "alternative_unit",
    data_type: "text",
    sequence: 1001,
    column_value: "",
    isVisible: false,
  },
  {
    id: -902,
    name: "Alternative Rate",
    column_name: "alternative_rate",
    data_type: "float",
    sequence: 1002,
    column_value: null,
    isVisible: false,
  },
  {
    id: -903,
    name: "Alternative Quantity",
    column_name: "alternative_quantity",
    data_type: "float",
    sequence: 1003,
    column_value: null,
    isVisible: false,
  },
];

export const BANK_STATEMENT_HEADER: BankStatementHeader[] = [
  {
    label: "UPLOADED FILE",
    value: "upload_file",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "BRANCH DETAILS",
    value: "branch_details",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "LEDGER NAME",
    value: "ledger_name",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "STATUS",
    value: "status",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "TOTAL TRANSACTIONS",
    value: "total_transaction",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "DATE RANGE",
    value: "date_range",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "UPLOADED AT",
    value: "uploaded_at",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "MODIFIED BY",
    value: "modified_by",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "BANK STATEMENT ID",
    value: "bank_statement_id",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "ACTION",
    value: "action",
    defaultChecked: true,
    checked: true,
  },
];

export const BankstatementStatus: StatusType[] = [
  {
    label: "READY",
    value: "READY",
  },
  {
    label: "PENDING",
    value: "PENDING",
  },
  {
    label: "FAILED",
    value: "FAILED",
  },
];

export const BANK_TRANSACTION_DETAILS_HEADER: InvoicingAdvanceHeadersType[] = [
  {
    label: "DATE",
    value: "date",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "NARRATION",
    value: "narration",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "AMOUNT",
    value: "amount",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "CUSTOMER/SUPPLIER/LEDGER",
    value: "ledger",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "ACTION",
    value: "action",
    defaultChecked: true,
    checked: true,
  },
];

export const BANK_TRANSACTION_IN_SORTING = [
  {
    id: "Recently Added/Modified First",
    name: "Recently Added/Modified First",
    value: "",
  },
  {
    id: "Transaction Date - Ascending",
    _id: "transaction_date",
    name: "Transaction Date - Ascending",
    value: "asc",
  },
  {
    id: "Transaction Date - Descending",
    _id: "transaction_date",
    name: "Transaction Date - Descending",
    value: "desc",
  },
  //***for the future use****
  // {
  //   id: "Transaction ID - Ascending",
  //   _id: "transaction_id",
  //   name: "Transaction ID - Ascending",
  //   value: "asc",
  // },
  // {
  //   id: "Transaction ID - Descending",
  //   _id: "transaction_id",
  //   name: "Transaction ID - Descending",
  //   value: "desc",
  // },
];
export const BANK_STATEMENT_IN_SORTING = [
  {
    id: "Recently Added/Modified First",
    name: "Recently Added/Modified First",
    value: "",
  },
  {
    id: "Bank Statement ID - Ascending",
    _id: "bank_statement_id",
    name: "Bank Statement ID - Ascending",
    value: "asc",
  },
  {
    id: "Bank Statement ID - Descending",
    _id: "bank_statement_id",
    name: "Bank Statement ID - Descending",
    value: "desc",
  },
  {
    id: "Date Range - Ascending",
    _id: "date_range_start",
    name: "Date Range - Ascending",
    value: "asc",
  },
  {
    id: "Date Range - Descending",
    _id: "date_range_start",
    name: "Date Range - Descending",
    value: "desc",
  },
];

export const BANK_TRANSACTION_TYPE_OPTIONS: RadioTypes[] = [
  { id: "credit", name: "Credit" },
  { id: "debit", name: "Debit" },
];

export const BANK_TRANSACTION_STATUS_OPTIONS: RadioTypes[] = [
  { id: "posted", name: "Posted" },
  { id: "not_posted", name: "Not Posted" },
  { id: "manually_posted", name: "Already Exists" },
];

export const RASPOLYPACKV2_PDF_TABLE_HEADERS: SinglePdfHeaderType[] = [
  {
    name: "No",
    column_value: "no",
  },
  {
    name: "Description",
    column_value: "description",
  },
  {
    name: "HSN/SAC",
    column_value: "hsn_sac_code",
  },
  {
    name: "Qty",
    column_value: "quantity",
  },
  {
    name: "Rate",
    column_value: "rate",
  },
  {
    name: "Unit",
    column_value: "unit",
  },
  {
    name: "Discount",
    column_value: "discount",
  },
  {
    name: "Taxable",
    column_value: "taxable_value",
  },
];
